<template>
  <div data-v-50da9dd9="" data-v-e5781868="" class="chess AS mainContent top50" style="background: #fafafa;">
    <div data-v-50da9dd9="" class="content">
      <div data-v-50da9dd9="" class="banner">
        <div data-v-50da9dd9="" class="swiper-container swiper-container-horizontal">
          <div class="swiper-wrapper" style="transform: translate3d(0px, 0px, 0px)">
            <div data-v-50da9dd9="" class="swiper-slide swiper-slide-active" style="width: 1330px">
              <div data-v-50da9dd9="" class="img"><img data-v-50da9dd9="" src="/static/image/banner-lottery-0d9ddb0eb2c895d7e717d5c7e81297eb1.jpg_.webp" /></div>
              <div data-v-50da9dd9="" class="info">
                <div data-v-50da9dd9="" class="title"></div>
     
              </div>
            </div>
          </div>
          <span class="swiper-notification" aria-live="assertive" aria-atomic="true"></span>
        </div>
      </div>
        <div data-v-50da9dd9="" class="list">
        <div data-v-50da9dd9="" class="t">
          <svg data-v-338e1447="" data-v-50da9dd9="" aria-hidden="true" class="svg-icon iconThumb">
            <use data-v-338e1447="" xlink:href="#icon-iconThumb"></use>
          </svg>
          热门游戏
          <div data-v-50da9dd9="" class="tools">
            <span data-v-50da9dd9="" slot="button-prev" class="item swiper-button-prev swiper-button-disabled" tabindex="0" role="button" aria-label="Previous slide" aria-disabled="true"
              ><svg data-v-338e1447="" data-v-50da9dd9="" aria-hidden="true" class="svg-icon icon iconArrowLeft">
                <use data-v-338e1447="" xlink:href="#icon-iconArrowLeft"></use></svg></span
            ><span data-v-50da9dd9="" slot="button-next" class="item swiper-button-next swiper-button-disabled" tabindex="0" role="button" aria-label="Next slide" aria-disabled="true"
              ><svg data-v-338e1447="" data-v-50da9dd9="" aria-hidden="true" class="svg-icon icon iconArrowRight">
                <use data-v-338e1447="" xlink:href="#icon-iconArrowRight"></use></svg
            ></span>
          </div>
        </div>
        <div data-v-50da9dd9="" class="c">
          <div data-v-50da9dd9="" class="swiper-container swiper swiper-container-horizontal">
            <div class="swiper-wrapper" style="transform: translate3d(0px, 0px, 0px)">
              <div data-v-50da9dd9="" class="swiper-slide swiper-slide-active" style="width: 317.5px; margin-right: 20px" v-for="(item, index) in gameList" :key="index"   v-if="item.app_state == 1" >
                <div data-v-50da9dd9="" class="item">
                  <div data-v-50da9dd9="" class="img">
                    <img data-v-50da9dd9="" :src="`/static/image/lottery/${item.platform_name}cp.png`" />
                    <div data-v-50da9dd9="" class="mask" style="display: none"><img data-v-50da9dd9="" src="/static/image/maintain.b2eb4b18.png" class="maintain" style="display: none" /><span data-v-50da9dd9="" class="t" style="display: none">游戏维护中</span></div>
                  </div>
                  <div data-v-50da9dd9="" class="info" v-if="item.app_state == 1 ">
                    <h3 data-v-50da9dd9="">{{item.name}}</h3>
                    <a data-v-50da9dd9="" class="button buttonBordered" @click="$parent.openGamePage(item.platform_name, item.game_code, '')"
                      >快速游戏
                      <svg data-v-338e1447="" data-v-50da9dd9="" aria-hidden="true" class="svg-icon iconArrow">
                        <use data-v-338e1447="" xlink:href="#icon-iconArrow"></use></svg
                    ></a>
                  </div>
                    <div data-v-50da9dd9="" class="info" v-else>
                    <h3 data-v-50da9dd9="">{{item.name}}</h3>
                    <a data-v-50da9dd9="" class="button buttonBordered" 
                      >维护中
                      <svg data-v-338e1447="" data-v-50da9dd9="" aria-hidden="true" class="svg-icon iconArrow">
                        <use data-v-338e1447="" xlink:href="#icon-iconArrow"></use></svg
                    ></a>
                  </div>
                </div>
              </div>
            
         
            </div>
            <span class="swiper-notification" aria-live="assertive" aria-atomic="true"></span><span class="swiper-notification" aria-live="assertive" aria-atomic="true"></span>
          </div>
        </div>
      </div>
      <div data-v-50da9dd9="" class="list" v-if="false">
        <div data-v-50da9dd9="" class="t">
          <svg data-v-338e1447="" data-v-50da9dd9="" aria-hidden="true" class="svg-icon iconThumb">
            <use data-v-338e1447="" xlink:href="#icon-iconThumb"></use>
          </svg>
          热门游戏
          <div data-v-50da9dd9="" class="tools">
            <span data-v-50da9dd9="" slot="button-prev" class="item swiper-button-prev swiper-button-disabled" tabindex="0" role="button" aria-label="Previous slide" aria-disabled="true"
              ><svg data-v-338e1447="" data-v-50da9dd9="" aria-hidden="true" class="svg-icon icon iconArrowLeft">
                <use data-v-338e1447="" xlink:href="#icon-iconArrowLeft"></use></svg></span
            ><span data-v-50da9dd9="" slot="button-next" class="item swiper-button-next swiper-button-disabled" tabindex="0" role="button" aria-label="Next slide" aria-disabled="true"
              ><svg data-v-338e1447="" data-v-50da9dd9="" aria-hidden="true" class="svg-icon icon iconArrowRight">
                <use data-v-338e1447="" xlink:href="#icon-iconArrowRight"></use></svg
            ></span>
          </div>
        </div>
        <div data-v-50da9dd9="" class="c">
          <div data-v-50da9dd9="" class="swiper-container swiper swiper-container-horizontal">
            <div class="swiper-wrapper" style="transform: translate3d(0px, 0px, 0px)">
   
              <div data-v-50da9dd9="" class="swiper-slide swiper-slide-active" style="width: 317.5px; margin-right: 20px">
                <div data-v-50da9dd9="" class="item">
                  <div data-v-50da9dd9="" class="img">
                    <img data-v-50da9dd9="" src="/static/image/form-2416-1-fef56ae60b9d644aa2c72fa99b0d10bd.png" />
                    <div data-v-50da9dd9="" class="mask" style="display: none"><img data-v-50da9dd9="" src="/static/image/maintain.b2eb4b18.png" class="maintain" style="display: none" /><span data-v-50da9dd9="" class="t" style="display: none">游戏维护中</span></div>
                  </div>
                  <div data-v-50da9dd9="" class="info">
                    <h3 data-v-50da9dd9="">TG彩票</h3>
                    <a data-v-50da9dd9="" class="button buttonBordered" @click="$parent.openGamePage('yb', '3', '')"
                      >快速游戏
                      <svg data-v-338e1447="" data-v-50da9dd9="" aria-hidden="true" class="svg-icon iconArrow">
                        <use data-v-338e1447="" xlink:href="#icon-iconArrow"></use></svg
                    ></a>
                  </div>
                </div>
              </div>
              <div data-v-50da9dd9="" class="swiper-slide swiper-slide-next" style="width: 317.5px; margin-right: 20px">
                <div data-v-50da9dd9="" class="item">
                  <div data-v-50da9dd9="" class="img">
                    <img data-v-50da9dd9="" src="/static/image/form-2416-1-26a7dac14277b2b6360309f2f1ebc044.png" />
                    <div data-v-50da9dd9="" class="mask" style="display: none" ><img data-v-50da9dd9="" src="/static/image/maintain.b2eb4b18.png" class="maintain" style="display: none" /><span data-v-50da9dd9="" class="t" style="display: none">游戏维护中</span></div>
                  </div>
                  <div data-v-50da9dd9="" class="info">
                    <h3 data-v-50da9dd9="">VR彩票</h3>
                    <a data-v-50da9dd9="" class="button buttonBordered" @click="$parent.openGamePage('vrbet', '3', '')"
                      >快速游戏
                      <svg data-v-338e1447="" data-v-50da9dd9="" aria-hidden="true" class="svg-icon iconArrow">
                        <use data-v-338e1447="" xlink:href="#icon-iconArrow"></use></svg
                    ></a>
                  </div>
                </div>
              </div>
              <div data-v-50da9dd9="" class="swiper-slide" style="width: 317.5px; margin-right: 20px">
                <div data-v-50da9dd9="" class="item">
                  <div data-v-50da9dd9="" class="img">
                    <img data-v-50da9dd9="" src="/static/image/form-2416-1-f4e7669934aaff51ed69ab4b2c32b516.png" />
                    <div data-v-50da9dd9="" class="mask" style="display: none" ><img data-v-50da9dd9="" src="/static/image/maintain.b2eb4b18.png" class="maintain" style="display: none" /><span data-v-50da9dd9="" class="t" style="display: none">游戏维护中</span></div>
                  </div>
                  <div data-v-50da9dd9="" class="info">
                    <h3 data-v-50da9dd9="">IG官方彩</h3>
                    <a data-v-50da9dd9="" class="button buttonBordered" @click="$parent.openGamePage('ig', 'GFC', '')"
                      >快速游戏
                      <svg data-v-338e1447="" data-v-50da9dd9="" aria-hidden="true" class="svg-icon iconArrow">
                        <use data-v-338e1447="" xlink:href="#icon-iconArrow"></use></svg
                    ></a>
                  </div>
                </div>
              </div>
              <div data-v-50da9dd9="" class="swiper-slide" style="width: 317.5px; margin-right: 20px">
                <div data-v-50da9dd9="" class="item">
                  <div data-v-50da9dd9="" class="img">
                    <img data-v-50da9dd9="" src="/static/image/form-2416-1-7ec51f151e1ab0484952bc12d03f27a7.png" />
                    <div data-v-50da9dd9="" class="mask" style="display: none"><img data-v-50da9dd9="" src="/static/image/maintain.b2eb4b18.png" class="maintain" /><span data-v-50da9dd9="" class="t">游戏维护中</span></div>
                  </div>
                  <div data-v-50da9dd9="" class="info">
                    <h3 data-v-50da9dd9="">IG香港彩</h3>
                    <a data-v-50da9dd9="" class="button buttonBordered" @click="$parent.openGamePage('ig', 'LOTTO', '')"
                      >快速游戏
                      <svg data-v-338e1447="" data-v-50da9dd9="" aria-hidden="true" class="svg-icon iconArrow">
                        <use data-v-338e1447="" xlink:href="#icon-iconArrow"></use></svg
                    ></a>
                  </div>
                </div>
              </div>
              <div data-v-50da9dd9="" class="swiper-slide" style="width: 317.5px; margin-right: 20px">
                <div data-v-50da9dd9="" class="item">
                  <div data-v-50da9dd9="" class="img">
                    <img data-v-50da9dd9="" src="/static/image/form-2416-1-7ec51f151e1ab0484952bc12d03f27a7.png" />
                    <div data-v-50da9dd9="" class="mask" style="display: none"><img data-v-50da9dd9="" src="/static/image/maintain.b2eb4b18.png" class="maintain" /><span data-v-50da9dd9="" class="t">游戏维护中</span></div>
                  </div>
                  <div data-v-50da9dd9="" class="info">
                    <h3 data-v-50da9dd9="">IG时时彩</h3>
                    <a data-v-50da9dd9="" class="button buttonBordered" @click="$parent.openGamePage('ig', 'LOTTERY', '')"
                      >快速游戏
                      <svg data-v-338e1447="" data-v-50da9dd9="" aria-hidden="true" class="svg-icon iconArrow">
                        <use data-v-338e1447="" xlink:href="#icon-iconArrow"></use></svg
                    ></a>
                  </div>
                </div>
              </div>
      
              <div data-v-50da9dd9="" class="swiper-slide" style="width: 317.5px; margin-right: 20px">
                <div data-v-50da9dd9="" class="item">
                  <div data-v-50da9dd9="" class="img">
                    <img data-v-50da9dd9="" src="/static/image/form-2416-1-7ec51f151e1ab0484952bc12d03f27a7.png" />
                    <div data-v-50da9dd9="" class="mask" style="display: none"><img data-v-50da9dd9="" src="/static/image/maintain.b2eb4b18.png" class="maintain" /><span data-v-50da9dd9="" class="t">游戏维护中</span></div>
                  </div>
                  <div data-v-50da9dd9="" class="info">
                    <h3 data-v-50da9dd9="">大立彩票</h3>
                    <a data-v-50da9dd9="" class="button buttonBordered" @click="$parent.openGamePage('dl', '2', '')"
                      >快速游戏
                      <svg data-v-338e1447="" data-v-50da9dd9="" aria-hidden="true" class="svg-icon iconArrow">
                        <use data-v-338e1447="" xlink:href="#icon-iconArrow"></use></svg
                    ></a>
                  </div>
                </div>
              </div>
              <div data-v-50da9dd9="" class="swiper-slide" style="width: 317.5px; margin-right: 20px">
                <div data-v-50da9dd9="" class="item">
                  <div data-v-50da9dd9="" class="img">
                    <img data-v-50da9dd9="" src="/static/image/form-2416-1-7ec51f151e1ab0484952bc12d03f27a7.png" />
                    <div data-v-50da9dd9="" class="mask" style="display: none"><img data-v-50da9dd9="" src="/static/image/maintain.b2eb4b18.png" class="maintain" /><span data-v-50da9dd9="" class="t">游戏维护中</span></div>
                  </div>
                  <div data-v-50da9dd9="" class="info">
                    <h3 data-v-50da9dd9="">BBIN彩票</h3>
                    <a data-v-50da9dd9="" class="button buttonBordered" @click="$parent.openGamePage('bbin', 'bbinlottery', '')"
                      >快速游戏
                      <svg data-v-338e1447="" data-v-50da9dd9="" aria-hidden="true" class="svg-icon iconArrow">
                        <use data-v-338e1447="" xlink:href="#icon-iconArrow"></use></svg
                    ></a>
                  </div>
                </div>
              </div>

              <div data-v-50da9dd9="" class="swiper-slide" style="width: 317.5px; margin-right: 20px">
                <div data-v-50da9dd9="" class="item">
                  <div data-v-50da9dd9="" class="img">
                    <img data-v-50da9dd9="" src="/static/image/form-2416-1-7ec51f151e1ab0484952bc12d03f27a7.png" />
                    <div data-v-50da9dd9="" class="mask" style="display: none"><img data-v-50da9dd9="" src="/static/image/maintain.b2eb4b18.png" class="maintain" /><span data-v-50da9dd9="" class="t">游戏维护中</span></div>
                  </div>
                  <div data-v-50da9dd9="" class="info">
                    <h3 data-v-50da9dd9="">天成彩票</h3>
                    <a data-v-50da9dd9="" class="button buttonBordered" @click="$parent.openGamePage('tc', '3', '')"
                      >快速游戏
                      <svg data-v-338e1447="" data-v-50da9dd9="" aria-hidden="true" class="svg-icon iconArrow">
                        <use data-v-338e1447="" xlink:href="#icon-iconArrow"></use></svg
                    ></a>
                  </div>
                </div>
              </div>
              <div data-v-50da9dd9="" class="swiper-slide" style="width: 317.5px; margin-right: 20px">
                <div data-v-50da9dd9="" class="item">
                  <div data-v-50da9dd9="" class="img">
                    <img data-v-50da9dd9="" src="/static/image/form-2416-1-7ec51f151e1ab0484952bc12d03f27a7.png" />
                    <div data-v-50da9dd9="" class="mask" style="display: none"><img data-v-50da9dd9="" src="/static/image/maintain.b2eb4b18.png" class="maintain" /><span data-v-50da9dd9="" class="t">游戏维护中</span></div>
                  </div>
                  <div data-v-50da9dd9="" class="info">
                    <h3 data-v-50da9dd9="">双赢彩票</h3>
                    <a data-v-50da9dd9="" class="button buttonBordered" @click="$parent.openGamePage('imone', '3', '')"
                      >快速游戏
                      <svg data-v-338e1447="" data-v-50da9dd9="" aria-hidden="true" class="svg-icon iconArrow">
                        <use data-v-338e1447="" xlink:href="#icon-iconArrow"></use></svg
                    ></a>
                  </div>
                </div>
              </div>
              <div data-v-50da9dd9="" class="swiper-slide" style="width: 317.5px; margin-right: 20px">
                <div data-v-50da9dd9="" class="item">
                  <div data-v-50da9dd9="" class="img">
                    <img data-v-50da9dd9="" src="/static/image/form-2416-1-7ec51f151e1ab0484952bc12d03f27a7.png" />
                    <div data-v-50da9dd9="" class="mask" style="display: none"><img data-v-50da9dd9="" src="/static/image/maintain.b2eb4b18.png" class="maintain" /><span data-v-50da9dd9="" class="t">游戏维护中</span></div>
                  </div>
                  <div data-v-50da9dd9="" class="info">
                    <h3 data-v-50da9dd9="">OB彩票</h3>
                    <a data-v-50da9dd9="" class="button buttonBordered" @click="$parent.openGamePage('obgcp', '2', '')"
                      >快速游戏
                      <svg data-v-338e1447="" data-v-50da9dd9="" aria-hidden="true" class="svg-icon iconArrow">
                        <use data-v-338e1447="" xlink:href="#icon-iconArrow"></use></svg
                    ></a>
                  </div>
                </div>
              </div>
            </div>
            <span class="swiper-notification" aria-live="assertive" aria-atomic="true"></span><span class="swiper-notification" aria-live="assertive" aria-atomic="true"></span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'lottery',
  data() {
    return {
         gameList: [],

    };
  },
  created() {
    let that = this;
    that.getGameList();
    
  },
  methods: {
            getGameList() {
      let that = this;
      that.$parent.showLoading();

      that.$apiFun.get('/api/game/list', { category: 'lottery' }).then(res => {
        if (res.code == 200) {
          that.gameList = res.data;
        }
        that.$parent.hideLoading();
      });
    },
    loginBox() {
      console.log($('.mask'));
      $('.mask').fadeOut(300);
      $('.mask.login').fadeIn(300);
    },
    registerBox() {
      $('.mask').fadeOut(300);
      $('.mask.register').fadeIn(300);
    },
    forgetBox() {
      $('.mask').fadeOut(300);
      $('.mask.forget').fadeIn(300);
    },
  },
  mounted() {
    let that = this;
  
  },
  updated() {
    let that = this;
    var mySwiper = new Swiper('.bannerSwiper .swiper', {
      slidesPerView: 'auto',
      pagination: {
        el: '.bannerSwiper .swiper-pagination',
        clickable: true,
      },
      navigation: {
        nextEl: '.bannerSwiper .swiper-button-next',
        prevEl: '.bannerSwiper .swiper-button-prev',
      },
    });
    var swiperList = new Swiper('.box .swiper-img', {
      navigation: {
        nextEl: '.swiper-img .swiper-button-next',
        prevEl: '.swiper-img .swiper-button-prev',
      },
    });
    var swiper = new Swiper('.k8BrandWay .c .timeline .swiper', {
      navigation: {
        nextEl: '.k8BrandWay .c .timeline .tool.next',
        prevEl: '.k8BrandWay .c .timeline .tool.prev',
      },
    });
    $('.k8BrandWay .c .timeline .swiper .swiper-slide .swiper-content .items .item').click(function () {
      $(this).addClass('active').siblings().removeClass('active');
      var u = $(this).index();
      var b = ((u + 1) / 7) * 100;
      console.log(b);
      $(this)
        .parents('.swiper-slide')
        .find('.swiper-content .line .activeState')
        .css('width', b + '%');
      var i = $(this).parents('.swiper-slide').index();
      if (i > 1) {
        for (var t = 0; t < i; t++) {
          if (t > 1) {
            $('.k8BrandWay .c .timeline .swiper .swiper-slide').eq(t).find('.swiper-content .line .activeState').css('width', '100%');
          }
        }
      }
      var m = i * 7;
      var o = m + u;
      swiperList.slideTo(o, 1000, false);
    });
    $('.table table tr').click(function () {
      $('.table table tr').removeClass('active');
      $(this).addClass('active');
      var username = $(this).find('td').eq(1).text();
      var amount = $(this).find('td').eq(2).text();
      $('.profit .user-name').text('会员' + username);
      $('.profit .amount h1').text(amount.replace('元', ''));
    });
    var gameSwipper = new Swiper('.banner .swiper-container', {

});
    var listSwipper = new Swiper('.swiper', {
      autoplay: {
        delay: 3000,
        stopOnLastSlide: false,
        disableOnInteraction: true,
      },
      slidesPerView: 4,
      spaceBetween: 20,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
    });
  },
  beforeDestroy() {},
};
</script>
<style lang="scss" scoped>
@import '../../../static/css/chunk-70b6a91e.6c8f8470.css';
</style>



// WEBPACK FOOTER //
// src/components/mode/lottery.vue